import React from 'react';
import logo from '../logo.png';

const Footer = () => {
  const year = new Date();
  return (
    <footer id='contact' className='bg-tr'>
      <div className='container'>
        <div className='s-40'></div>
        <div className='row'>
          <div className='col-lg-6'>
            <div className='s-m-40'></div>
            <a href='/' aria-label='Codereview - Home'>
              <img
                src={logo}
                height={48}
                alt='Codereview'
                style={{ transform: 'translateY(-5px)' }}
              />
            </a>
            <div className='s-40'></div>
            <div className='s-m-40'></div>
            <p className='c-white'>
              <a href='/'>@{year.getFullYear()} - ГО Застраховано</a>. Усі права
              захищено
            </p>
          </div>
          <div className='col-lg-6 tr'>
            <div className='s-20'></div>
            <address className='c-white'>
              Громадська організація «Застраховано»
              <br />
              <div className='s-10'></div>
              {/*ЄДРПОУ: XXXXXXXX*/}
            </address>
            <div className='s-30'></div>
            <div className='legal-links' style={{ fontSize: '14px', lineHeight: '1.4' }}>
              <a href='https://docs.google.com/document/d/1B_aoneZ2x6s5cCq_BW8XfXLGXrG_o-Vj1sYwLvsplrA/edit?usp=sharing' target='_blank' rel="noreferrer" className='c-white'>Політика конфіденційності</a> • 
              <a href='https://docs.google.com/document/d/1DR9Z0LPC6GlYBlGcBWraCn-sPnsYT7AmQJYASznBNi4/edit?usp=sharing' target='_blank' rel="noreferrer" className='c-white'> Політика Cookies</a> • 
              <a href='https://docs.google.com/document/d/1ehjKo88n8XQQ65VcudcPYgmzLy_CCuWoEgAuouxZslQ/edit?usp=sharing' target='_blank' rel="noreferrer" className='c-white'> Публічна оферта</a> • 
              <a href='https://docs.google.com/document/d/1MtpSCvW-4TGC8naZjFAwmcbBnLdGgVgJHBhGkq9UoMg/edit?usp=sharing' target='_blank' rel="noreferrer" className='c-white'> Умови повернення коштів</a> •
              <a href='https://docs.google.com/document/d/10-WT3OciJFv5mCe_4qoYezaORI9twTVWfTOh3s2CESg/edit?usp=sharing' target='_blank' rel="noreferrer" className='c-white'> Партнерська угода</a>
            </div>
          </div>
        </div>
        <div className='s-30'></div>
      </div>
    </footer>
  );
};

export { Footer };
